import { combineReducers } from "redux";

const popupReducer = (state = false, action) => {
  switch (action.type) {
    case "SHOW_VALIDATION_POPUP":
      return {
        message: action.payload.message,
        icon: action.payload.icon,
        type: action.payload.type,
        scopePath: action.payload.scopePath,
      };
    case "HIDE_VALIDATION_POPUP":
      return false;
    default:
      return state;
  }
};

const PopupReducer = (state = false, action) => {
  switch (action.type) {
    case "SHOW_POPUP":
      return action.payload;
    case "HIDE_POPUP":
      return false;
    default:
      return state;
  }
};

const forgotPasswordAndCheckEmailReducer = (
  state = { forgotPasswordPopup: false, checkEmailPopup: false },
  action
) => {
  switch (action.type) {
    case "SHOW_FORGOT_PASSWORD_POPUP":
      return {
        ...state,
        forgotPasswordPopup: true,
      };
    case "HIDE_FORGOT_PASSWORD_POPUP":
      return {
        ...state,
        forgotPasswordPopup: false,
      };
    case "SHOW_CHECK_EMAIL_POPUP":
      return {
        ...state,
        checkEmailPopup: true,
      };
    case "HIDE_CHECK_EMAIL_POPUP":
      return {
        ...state,
        checkEmailPopup: false,
      };
    default:
      return state;
  }
};

const resetPasswordReducer = (
  state = {
    resetPasswordPopup: false,
    resetToken: null,
    successPopup: false,
    resetId: false,
  },
  action
) => {
  switch (action.type) {
    case "SHOW_RESET_PASSWORD_POPUP":
      return {
        ...state,
        resetPasswordPopup: true,
        resetToken: action.payload.token,
        resetId: action.payload.id,
      };
    case "HIDE_RESET_PASSWORD_POPUP":
      return {
        ...state,
        resetPasswordPopup: false,
        resetToken: null,
        resetId: null,
      };
    case "SHOW_PASSWORD_RESET_SUCCESS_POPUP":
      return {
        ...state,
        successPopup: true,
      };
    case "HIDE_PASSWORD_RESET_SUCCESS_POPUP":
      return {
        ...state,
        successPopup: false,
      };
    default:
      return state;
  }
};
const userTokenReducer = (state = false, action) => {
  switch (action.type) {
    case "SET_USER_TOKEN":
      return action.payload;
    default:
      return state;
  }
};
export default combineReducers({
  validationPopup: popupReducer,
  Popup: PopupReducer,
  forgotPasswordAndCheckEmail: forgotPasswordAndCheckEmailReducer,
  resetPassword: resetPasswordReducer,
  userToken: userTokenReducer,
});
